import { Injectable } from '@angular/core';
import { ConfigService, HttpWrapperService } from '@gbs-platform-client/fwk-core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { APIResponse } from 'src/app/utils/models/response';
import { Menu } from '../models/menu';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  apiEndpoint: string = "";
  apiUniqueId: string = "menu/id/D32A6CC9-353B-4E23-90FB-3C410CD6FD7E";

  constructor(private httpService: HttpWrapperService,
    private configService: ConfigService) {
    this.apiEndpoint = this.configService.getConfigValue('apiEndpoint');
    this.apiEndpoint += this.apiUniqueId;
  }

  getAllMenus(filter: string, pagesize: number, pagenumber: number): Observable<Array<Menu>> {
    return this.httpService.get(this.apiEndpoint + 'getAllMenus?filter=' + (filter ? filter : '') + '&pageSize=' + (pagesize ? pagesize : 0) + '&pageNumber=' + (pagenumber ? pagenumber : 0)).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  viewMenuByModule(ModuleId?: string): Observable<Array<any>> {
    return this.httpService.get(this.apiEndpoint + '/viewMenuByModule/' + (ModuleId ? ModuleId : '')).pipe(map((response: any) => {
      return response.Data;

    }));
  }
  viewMenu(EntityID?: string): Observable<Array<Menu>> {
    return this.httpService.get(this.apiEndpoint + '/viewMenu/' + (EntityID ? EntityID : '')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }
  getMenuDetailsByLink(menuUrl: string): Observable<string> {
    menuUrl = menuUrl.replace(new RegExp('/', 'g'), '^');
    return this.httpService.get(this.apiEndpoint + '/getMenuDetailsByLink/' + (menuUrl ? menuUrl : '')).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data[0].Menu_Breadcrump;
      } else {
        return [];
      }
    }));
  }
  saveMenu(level1: Menu): Observable<any> {
    return this.httpService.post(this.apiEndpoint + '/saveMenu/', level1).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  deleteMenu(EntityID?: string): Observable<any> {
    return this.httpService.post(this.apiEndpoint + '/deleteMenu/' + (EntityID ? EntityID : ''), EntityID).pipe(map((result: any) => {
      if (result.Success) {
        return result.Data;
      } else {
        return [];
      }
    }));
  }

  checkDuplication(Entity_Name?: string, Entity_Id?: string): Observable<any> {
    return this.httpService.get(this.apiEndpoint + '/checkDuplication?MenuName=' + (Entity_Name ? Entity_Name : '') + '&MenuId=' + (Entity_Id ? Entity_Id : 0)).pipe(map((result: any) => {
      return result;
    }));

  }
}
